import { render, staticRenderFns } from "./tihuanKt.vue?vue&type=template&id=74b1261a&scoped=true"
import script from "./tihuanKt.vue?vue&type=script&lang=js"
export * from "./tihuanKt.vue?vue&type=script&lang=js"
import style0 from "./tihuanKt.vue?vue&type=style&index=0&id=74b1261a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b1261a",
  null
  
)

export default component.exports